import CircularProgress from '@material-ui/core/CircularProgress'
import {FixedCenter} from './loadingElements'

const Loading = () => {
    return (
        <FixedCenter>
            <CircularProgress color="secondary" />
        </FixedCenter>
    )
}

export default Loading
